export default class UserRoleItem
{
	constructor(role, rolestr) 
	{
		if(role)
		{
			this.RoleId = role.RoleId;
			this.Name = role.Name;
			this.UserHasIt=rolestr.split(", ").includes(role.Name);//(", "+rolestr+",").includes(", "+role.Name+",");
		}
	}
}
